const TGWE_HOSTS = new Set(["thegreatworkexperience.com", "www.thegreatworkexperience.com"]);

export function isPdfHref(href) {
  if (!href) return false;

  const path = String(href).trim().split(/[?#]/)[0];
  return /\.pdf$/i.test(path);
}

export function isExternalHref(href) {
  if (!href) return false;

  const value = String(href).trim();
  if (!value || value.startsWith("#") || value.startsWith("/")) return false;
  if (/^(mailto:|tel:)/i.test(value)) return true;
  if (!/^(https?:)?\/\//i.test(value)) return false;

  try {
    const url = value.startsWith("//") ? new URL(`https:${value}`) : new URL(value);
    return !TGWE_HOSTS.has(url.hostname.toLowerCase());
  } catch {
    return false;
  }
}

export function externalLinkProps(href) {
  return isExternalHref(href) || isPdfHref(href) ? { target: "_blank", rel: "noopener noreferrer" } : {};
}
